import { ThemeContent, LessonPart } from './types';
import ai from './ai';
import dg from './dg';
import mw from './mw';
import dv from './dv';
import sm from './sm';
import { ThemeId } from '../learning';

const BY_THEME: Record<ThemeId, ThemeContent> = { ai, dg, mw, dv, sm };

export function getLessonParts(themeId: ThemeId, moduleIdx: number): LessonPart[] {
  return BY_THEME[themeId]?.[moduleIdx] || [];
}

export type { LessonPart };
